import { ActionTree } from 'vuex';
import { IStoreRootState } from '@/store/interface';
import { ForexHistoryState } from '@/feature/TrHistory/store/interface';
import { $getForexHistoryListOnce } from '@/feature/TrHistory/api/forex-history';
import { ForexHistoryAction, ForexHistoryGetter, ForexHistoryMutation } from '@/feature/TrHistory/store/constants';
import {
	getHistoryFilter,
	getHistoryNextPageFilters,
	nextPageIsAvailable
} from '@/feature/TrHistory/store/utils';

export default <ActionTree<ForexHistoryState, IStoreRootState>> {

	async [ForexHistoryAction.loadNextPage](context) {
		if (!nextPageIsAvailable(context, ForexHistoryGetter.loading))
			return [];

		return context.dispatch(
			ForexHistoryAction.loadPage,
			getHistoryNextPageFilters(context.state, context.commit)
		);
	},

	async [ForexHistoryAction.loadPage]({ state, commit }) {
		commit(ForexHistoryMutation.setLoading, true);

		const list = await $getForexHistoryListOnce(getHistoryFilter(state));

		commit(ForexHistoryMutation.addList, list);
		commit(ForexHistoryMutation.setLoading, false);

		if (list.length < state.pageSize)
			commit(ForexHistoryMutation.setIsEndPage, true);

		return list;
	},

	async [ForexHistoryAction.reloadPage]({ state, commit, dispatch }) {
		commit(ForexHistoryMutation.resetPage);

		return dispatch(ForexHistoryAction.loadPage, getHistoryFilter(state));
	},

}
